"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMeetingsEndpoints = createMeetingsEndpoints;
/**
 * Etkinlik öncesi görüşme talebi ve görüşme alanları (Epic 12).
 */
function createMeetingsEndpoints(client) {
    return {
        /**
         * Görüşme talebi (Epic 12). Yazma uçlarının hepsi etkinlik kapsamındadır;
         * kutu ve engelleme uçları kullanıcının KENDİ yüzeyidir.
         *
         * KIRMIZI ÇİZGİ 2: alıcı ulaşılamazsa (görünmez / talep yüzeyi kapalı /
         * engellemiş / hiç yok) sunucu 404 döner ve gövde hiç var olmayan
         * kullanıcıyla BİREBİR aynıdır — istemci bu ayrımı YENİDEN KURMAZ, sebebi
         * ekranda YAZMAZ.
         */
        meetings: {
            eligibility: (eventId, recipientUserId) => client.call('/events/{eventId}/meeting-requests/eligibility/{recipientUserId}', 'get', {
                path: { eventId, recipientUserId },
            }),
            send: (eventId, input) => client.call('/events/{eventId}/meeting-requests', 'post', {
                path: { eventId },
                body: input,
            }),
            detail: (eventId, meetingRequestId) => client.call('/events/{eventId}/meeting-requests/{meetingRequestId}', 'get', {
                path: { eventId, meetingRequestId },
            }),
            /** Kabulde slot ZORUNLU, rette YASAK (şema `forbidden` ile zorlar). */
            respond: (eventId, meetingRequestId, input) => client.call('/events/{eventId}/meeting-requests/{meetingRequestId}/respond', 'post', {
                path: { eventId, meetingRequestId },
                body: input,
            }),
            cancel: (eventId, meetingRequestId) => client.call('/events/{eventId}/meeting-requests/{meetingRequestId}/cancel', 'post', {
                path: { eventId, meetingRequestId },
            }),
            /** Gelen / gönderilen kutusu — tüm etkinlikleri kapsar, `eventId` süzgeçtir. */
            myRequests: (query) => client.call('/users/me/meeting-requests', 'get', { query: query }),
            /**
             * Rozet sayacı (Blok 16): tek sayı. Gezinme kabuğu bunun için artık
             * talep LİSTESİNİ çekmiyor — sayı sayfa boyutundan bağımsız KESİNDİR.
             */
            pendingCount: () => client.call('/users/me/meeting-requests/pending-count', 'get', {}),
            blocks: () => client.call('/users/me/meeting-blocks', 'get', {}),
            /** 204 döner; sonuç `blocks()` ile okunur (hedefin durumu sızmasın diye). */
            block: (input) => client.call('/users/me/meeting-blocks', 'post', { body: input }),
            unblock: (blockedUserId) => client.call('/users/me/meeting-blocks/{blockedUserId}', 'delete', {
                path: { blockedUserId },
            }),
            /** Kişisel ajanda (ekran 10d): oturum + kabul edilmiş görüşme tek akışta. */
            myAgenda: (query) => client.call('/users/me/agenda', 'get', { query: query ?? {} }),
            // --- Organizatör: görüşme alanları (Story 13.2) ------------------------
            areas: (eventId) => client.call('/events/{eventId}/meeting-areas', 'get', { path: { eventId } }),
            createArea: (eventId, input) => client.call('/events/{eventId}/meeting-areas', 'post', {
                path: { eventId },
                body: input,
            }),
            updateArea: (eventId, areaId, input) => client.call('/events/{eventId}/meeting-areas/{areaId}', 'patch', {
                path: { eventId, areaId },
                body: input,
            }),
            /** Özet satırı: yer bekleyen görüşme sayısı (13.10.2026) — kimlik DÖNMEZ. */
            areaSummary: (eventId) => client.call('/events/{eventId}/meeting-areas/summary', 'get', { path: { eventId } }),
            /** Silme uyarısı için etki özeti — taraf kimliği DÖNMEZ. */
            areaImpact: (eventId, areaId) => client.call('/events/{eventId}/meeting-areas/{areaId}/impact', 'get', {
                path: { eventId, areaId },
            }),
            deleteArea: (eventId, areaId, reassignToAreaId) => client.call('/events/{eventId}/meeting-areas/{areaId}', 'delete', {
                path: { eventId, areaId },
                query: (reassignToAreaId ? { reassignToAreaId } : {}),
            }),
        },
    };
}
//# sourceMappingURL=meetings.js.map